import {
  GridEventListener,
  GridRowEditStopReasons,
  GridRowId,
} from "@mui/x-data-grid";

import { SelectChangeEvent } from "@mui/material";
import {
  GroupStructure,
  ManagerUsersConfigRows,
} from "../../../../../redux/slices/users/createUsers";

export const handleRowEditStop: GridEventListener<"rowEditStop"> = (
  params,
  event,
) => {
  if (params.reason === GridRowEditStopReasons.rowFocusOut) {
    event.defaultMuiPrevented = true;
  }
};

export const handleDeleteClick =
  (
    id: GridRowId,
    managerUsersConfigRows: ManagerUsersConfigRows[],
    setManagerRows: (value: ManagerUsersConfigRows[]) => void,
  ) =>
  () => {
    setManagerRows(managerUsersConfigRows.filter((row) => row.id !== id));
  };

export const handleChangeGroups = (
  event: SelectChangeEvent<any>,
  id: number,
  managerUsersConfigRows: ManagerUsersConfigRows[],
  setManagerRows: (value: ManagerUsersConfigRows[]) => void,
  groups: any[],
) => {
  const {
    target: { value },
  } = event;

  setManagerRows(
    managerUsersConfigRows.map((row) =>
      row.id === id
        ? {
            ...row,
            assignedGroups: value === "string" ? value.split(",") : value,
            groupsSelected: groups.filter((s: GroupStructure) =>
              value.flat().includes(s.id),
            ),

            groupsLocationsSelectedIds: [
              ...new Set(
                groups
                  .filter((s: GroupStructure) => value.flat().includes(s.id))
                  .map((g) => g.locations)
                  .flat(),
              ),
            ],
          }
        : row,
    ),
  );
};

export const handleChangeEmail = (
  event: any,
  id: string,
  managerUsersConfigRows: ManagerUsersConfigRows[],
  setManagerRows: (value: ManagerUsersConfigRows[]) => void,
) => {
  const {
    target: { value },
  } = event;

  const sanitized = typeof value === "string" ? value.replace(/\s/g, "") : value;
  setManagerRows(
    managerUsersConfigRows.map((row: any) =>
      row.id === id
        ? {
            ...row,
            email: sanitized === "string" ? sanitized.split(",") : sanitized,
          }
        : row,
    ),
  );
};

export const handleChangeRole = (
  event: any,
  id: number,
  managerUsersConfigRows: ManagerUsersConfigRows[],
  setManagerRows: (value: ManagerUsersConfigRows[]) => void,
) => {
  const {
    target: { value },
  } = event;

  setManagerRows(
    managerUsersConfigRows.map((row) =>
      row.id === id
        ? {
            ...row,
            role: value === "string" ? value.split(",") : value,
          }
        : row,
    ),
  );
};

export const handleSiteChange = (
  locationID: number,
  locationName: string,
  id: number,
  managerUsersConfigRows: ManagerUsersConfigRows[],
  setManagerRows: (value: ManagerUsersConfigRows[]) => void,
) => {
  setManagerRows(
    managerUsersConfigRows.map((row) =>
      row.id === id
        ? {
            ...row,
            assignedSite: {
              name: locationName,
              id: locationID,
            },
          }
        : row,
    ),
  );
};

export const handleSiteChangeToNull = (
  id: number,
  managerUsersConfigRows: ManagerUsersConfigRows[],
  setManagerRows: (value: ManagerUsersConfigRows[]) => void,
) => {
  setManagerRows(
    managerUsersConfigRows.map((row) =>
      row.id === id
        ? {
            ...row,
            assignedSite: null,
          }
        : row,
    ),
  );
};
